import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/LogoDPX2.png'; // versión en blanco para el fondo oscuro
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-grid">
                {/* LOGO */}
                <div className="footer-col logo-col">
                    <img
                        src={logo}
                        alt="DanPauleX, operador de transportes"
                        loading="lazy"
                        decoding="async"
                    />
                </div>

                {/* SERVICIOS */}
                <div className="footer-col">
                    <h4>SERVICIOS</h4>
                    <Link to="/servicios">Transporte industrial</Link>
                    <Link to="/servicios">Transporte de material para eventos</Link>
                    <Link to="/servicios">Vehículos especializados</Link>
                </div>

                {/* CONTACTO */}
                <div className="footer-col">
                    <h4>CONTACTO</h4>
                    <Link to="/contacto">Contáctanos</Link>
                    <a href="mailto:contacto@danpaulex.com">contacto@danpaulex.com</a>
                </div>

                {/* LINKS DE REFERENCIA */}
                <div className="footer-col">
                    <h4>LINKS DE REFERENCIA</h4>
                    <Link to="/aviso-legal">Aviso legal</Link>
                    <Link to="/politica-privacidad">Política de Privacidad</Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
